import { render, staticRenderFns } from "./ImageSectionErvarenVoiceOverText.vue?vue&type=template&id=655a4a54&"
import script from "./ImageSectionErvarenVoiceOverText.vue?vue&type=script&lang=js&"
export * from "./ImageSectionErvarenVoiceOverText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports